import React from 'react'
import PropTypes from 'prop-types'

import colors from '@settings/styleSettings'

const IconFilterFields = ({ orderBy, color }) => {

  function statusArrowDesc() {
    return (orderBy === 'desc') ? colors.primary : color || colors.strongGray
  }
  function statusArrowAsc() {
    return (orderBy === 'asc') ? colors.primary : color || colors.strongGray
  }
  return (
    <svg width={18} xmlns="http://www.w3.org/2000/svg" viewBox="1 -1 16 16">
      <svg height="17" viewBox="3 0 7 16">
        <path
          fill={!orderBy ? color || colors.strongGray : statusArrowDesc()}
          d="M.155 6.138a.477.477 0 01.36-.15.514.514 0 01.361.16l2.181 2.18V.5c0-.141.048-.26.144-.356A.483.483 0 013.556 0c.142 0 .26.048.356.143A.483.483 0 014.055.5v7.83L6.253 6.13a.473.473 0 01.348-.148.49.49 0 01.357.155.49.49 0 01.155.355.49.49 0 01-.155.356l-2.98 2.98a.55.55 0 01-.423.171.552.552 0 01-.42-.17L.138 6.833A.452.452 0 010 6.495a.49.49 0 01.155-.357z"
        />
      </svg>
      <svg height="17" x="5" fill="none" viewBox="2.5 0 7 16">
        <path
          fill={!orderBy ? color || colors.strongGray : statusArrowAsc()}
          d="M7.394 3.862a.477.477 0 01-.361.15.514.514 0 01-.36-.16L4.49 1.672V9.5c0 .141-.047.26-.143.356a.483.483 0 01-.356.143.483.483 0 01-.355-.143.483.483 0 01-.144-.356V1.67L1.296 3.87a.473.473 0 01-.349.148.49.49 0 01-.356-.155.49.49 0 01-.155-.355.49.49 0 01.155-.356L3.57.17A.55.55 0 013.993 0a.552.552 0 01.42.17l2.998 2.997c.092.09.138.203.138.338a.49.49 0 01-.155.357z"
        />
      </svg>
    </svg>
  )
}

IconFilterFields.propTypes = {
  orderBy: PropTypes.string,
  color: PropTypes.string
}

IconFilterFields.defaultProps = {
  orderBy: null,
  color: colors.strongGray
}

export default IconFilterFields
